import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import ProposalDetailsForm from "./indexForm";
import { ReducerUtils } from "../../../constants/reducers";
import { Utils } from "../../../constants/utils";
import { Box } from "@mui/material";
import {
  errorMessageObject,
  formObject,
  options,
  occupationObject,
  occupationHouseWifeObject,
  sectionObject,
  touchFieldObject,
} from "../../../defaultValues/proposal";
import {
  getRoute,
  getStorageItem,
  makeid,
  rebuildOccupationList,
  setStorageItem,
} from "../../../helpers/utils";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import {
  buildUpdateCustomerDetails,
  buildVerifyPancardPayload,
} from "../../../helpers/proposal";
import { postWebService } from "../../../helpers/server";
import { useHistory } from "react-router";
import { validations } from "../../../messages/validation";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { isValidPAN } from "../../../helpers/validation";

function ProposalDetails({ classes: { loaderBox } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState({ ...errorMessageObject });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...formObject });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    occupation: false,
    pancard: false,
    panMismatch: false,
  });
  const [section, setSection] = useState({ ...sectionObject });
  const [touchFields, setTouchFields] = useState({ ...touchFieldObject });
  const [selectedOccupationOption, setSelectedOccupationOption] =
    useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [panErrorMessage, setPanErrorMessage] = useState("");
  const [isPanVerifiedError, setIsPanVerifiedError] = useState(false);
  const [panDetails, setPanDetails] = useState(null);

  useEffect(() => {
    const cbSuccessOccupationList = ({ data }) => {
      dispatchEvent(ReducerUtils.occupation.list, rebuildOccupationList(data));
    };

    async function fetchOccupationList() {
      try {
        const response = await postWebService("occupations.php", {});

        cbSuccessOccupationList(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    const cbSuccessOrderDetails = ({
      fatherName,
      is_pan_verified,
      panNumber,
      product_config = null,
      occupation: occupation_type = "",
      annualIncome: annual_income = "",
      education = "",
    }) => {
      setForm({
        ...form,
        ...(fatherName && { father_name: fatherName }),
        ...(panNumber && { pan_number: panNumber, income_tax_proof: "PAN" }),
        ...(is_pan_verified && {
          verify_pan_number: is_pan_verified ? true : false,
        }),
        ...(product_config && { productConfig: JSON.parse(product_config) }),
        ...(occupation_type && { occupation_type }),
        ...(annual_income && { annual_income }),
        ...(education && { education }),
        ...(occupation_type === "Housewife" && {
          organisation_name: "Housewife",
        }),
      });
      setTimeout(() => setIsLoaded(true), 100);
    };

    async function fetchOrderDetails() {
      try {
        const response = await postWebService("orders.php", {
          oid: Number(getStorageItem("oid")),
        });
        setOrderDetails(response.data);
        cbSuccessOrderDetails(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    const cbSuccessWrapperToken = ({ access_token }) => {
      setStorageItem("access-token", access_token);
      fetchOccupationList();
      fetchOrderDetails();
    };

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        cbSuccessWrapperToken(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  useEffect(() => {
    selectedOccupationOption?.risk_categorization === "High" &&
      toggleModal("occupation", true);
  }, [selectedOccupationOption]);

  useEffect(() => {
    form.occupation_type === "Housewife"
      ? syncHousewifeDetails()
      : syncSalariedBusinessDetails();
  }, [form.occupation_type]);

  useEffect(() => validateRequiredInput("father_name"), [form.father_name]);

  useEffect(
    () => validateRequiredInput("organisation_name"),
    [form.organisation_name]
  );

  useEffect(() => {
    validateIncomeInput("annual_income");
    setForm({
      ...form,
      ...(form.annual_income >= 250000 && { income_tax_proof: "PAN" }),
    });
  }, [form.annual_income]);

  useEffect(() => {
    setForm({
      ...form,
      ...(form.annual_income >= 250000 && { income_tax_proof: "PAN" }),
    });
  }, [form.income_tax_proof]);

  useEffect(() => {
    validatePAN("pan_number");
    setFormState(
      "verify_pan_number",
      orderDetails?.is_pan_verified ? true : false
    );
  }, [form.pan_number]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleAccordionChange = (keyname, flag) => {
    const shallowCopy = { ...section };
    for (const key in shallowCopy) {
      if (keyname != key) {
        shallowCopy[key] = false;
      }
    }
    shallowCopy[keyname] = !flag;
    setSection(shallowCopy);
  };

  const handleBack = () => navigateTo(`${getRoute("overview")}/3`);

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleChangeChipSelect = (name, value) => setFormState(name, value);

  const handleCheckboxChange = (event) =>
    setFormState([event.target.name], event.target.checked);

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) => {
    toggleModal(modalKey, false);
    modalKey === "occupation" && updateCustomerDetails(true);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const syncHousewifeDetails = () => {
    setSelectedOccupationOption({ ...occupationHouseWifeObject });
    setFormState("organisation_name", "Housewife");
  };

  const syncSalariedBusinessDetails = () => {
    setSelectedOccupationOption({ ...occupationObject });
    setFormState("organisation_name", "");
  };

  const validateIncomeInput = (fieldName) => {
    if (form[fieldName]) {
      const isValid = form[fieldName] >= 100000;
      if (isValid) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else {
        setErrorMessageState(fieldName, validations[fieldName].valid);
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (
      event.target.name === "annual_income" ||
      event.target.name === "einsurance_account_number"
    ) {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (event.target.name === "pan_number") {
      var clean = elValue.replace(/[^0-9A-Za-z]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const validatePAN = (fieldName) => {
    if (form[fieldName]) {
      const isValid = isValidPAN(form[fieldName]);
      if (isValid) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else {
        setErrorMessageState(fieldName, validations[fieldName].valid);
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const toggleModal = (keyname = "open", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  const cbSuccessVerifyPancardDetailsPerfios = ({ data }, checksum) => {
    setIsFormSubmitted(false);
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);
    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.code == 200 && dataJSON.checksum == checksum) {
      const isValid = dataJSON.isValid ?? null;
      setForm({
        ...form,
        verify_pan_number: isValid ? true : false,
      });
      setIsFormSubmitted(false);
      !isValid && toggleModal("pancard", true);
    } else {
      setForm({
        ...form,
        verify_pan_number: false,
      });
      setIsFormSubmitted(false);
      toggleModal("pancard", true);
    }
  };

  const verifyPancardDetailsPerfios = async () => {
    try {
      setIsFormSubmitted(true);

      const checksum = makeid();
      const response = await postWebService(
        "verifyPANdetails.php",
        buildVerifyPancardPayload(form, checksum)
      );

      cbSuccessVerifyPancardDetailsPerfios(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const validPanDetailsHandler = (dataJSON = null) => {
    const isValid = dataJSON.isValid ?? false;
    const data = dataJSON?.data ?? null;

    setPanDetails(data);
    setModal({ ...modal, panMismatch: isValid && data });
    setIsPanVerifiedError(!isValid);
    setForm({
      ...form,
      verify_pan_number: isValid ? true : false,
    });

    !isValid && toggleModal("pancard", true);
  };

  const inValidPanDetailsHandler = (dataJSON = null) => {
    const message =
      dataJSON?.message ?? "Error in PAN Verification. Please try again.";
    setIsPanVerifiedError(true);
    setPanErrorMessage(message);

    if (dataJSON?.code == 403) {
      terminateJourneyHandler(dataJSON?.message);
    }
  };

  const cbSuccessVerifyPancardDetails = ({ data }, checksum) => {
    setIsFormSubmitted(false);

    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);
    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.checksum == checksum) {
      dataJSON.code == 200
        ? validPanDetailsHandler(dataJSON)
        : inValidPanDetailsHandler(dataJSON);
    } else {
      inValidPanDetailsHandler(
        dataJSON,
        "Invalid Checksum Received: Not able to process this request."
      );
    }
  };

  const verifyPancardDetails = async () => {
    try {
      setIsFormSubmitted(true);
      setPanErrorMessage("");
      const checksum = makeid();
      const response = await postWebService(
        "verifypan.php",
        buildVerifyPancardPayload(form, checksum)
      );

      cbSuccessVerifyPancardDetails(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const terminateJourneyHandler = (message = "") => {
    setIsFormSubmitted(false);
    setStorageItem("journeyCloseReason", message);
    navigateTo(getRoute("terminated"));
  };

  const cbTermimateJourney = () => {
    setIsFormSubmitted(false);
    setStorageItem(
      "journeyCloseReason",
      "Unfortunately we will not be able to proceed ahead due to high risk occupation."
    );
    navigateTo(getRoute("terminated"));
  };

  const cbSuccessCreateOpportunity = () => {
    setIsFormSubmitted(false);
    navigateTo(getRoute("nominee"));
  };

  const createOpportunity = async () => {
    try {
      const response = await postWebService("opportunity.php", {
        oid: Number(getStorageItem("oid")),
      });

      if (response.data.code === 200) {
        cbSuccessCreateOpportunity();
      }
    } catch (error) {
      cbError(error);
    }
  };

  const updateOrderDetails = async () => {
    try {
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        status: "ADDITIONALDETAILS",
      });

      if (response.data.code === 201) {
        createOpportunity();
      }
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessUpdateCustomer = (terminated) =>
    terminated ? cbTermimateJourney() : updateOrderDetails();

  const updateCustomerDetails = async (terminated = false) => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService(
        "update-customer.php",
        buildUpdateCustomerDetails(form, selectedOccupationOption, terminated)
      );

      if (response.data.code === 200) {
        cbSuccessUpdateCustomer(terminated);
      }
    } catch (error) {
      cbError(error);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    updateCustomerDetails();
  };

  return isLoaded && state?.occupations.length > 0 ? (
    <ProposalDetailsForm
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleAccordionChange={handleAccordionChange}
      handleBack={handleBack}
      handleChange={handleChange}
      handleChangeChipSelect={handleChangeChipSelect}
      handleCheckboxChange={handleCheckboxChange}
      handleClose={handleClose}
      handleOnClose={handleOnClose}
      isFormSubmitted={isFormSubmitted}
      isLoaded={isLoaded}
      modal={modal}
      occupations={state?.occupations}
      onSubmit={onSubmit}
      options={options}
      orderDetails={orderDetails}
      panDetails={panDetails}
      panErrorMessage={panErrorMessage}
      isPanVerifiedError={isPanVerifiedError}
      section={section}
      selectedOccupationOption={selectedOccupationOption}
      setSelectedOccupationOption={setSelectedOccupationOption}
      validateInputLength={validateInputLength}
      verifyPancardDetails={verifyPancardDetails}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProposalDetails);
